import { StoreIcon } from './StoreIcon';

/**
 * author: Google
 * id 3C3AEDE0-B6DA-4CB9-A686-869634678D5D
 * name store
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreMallDirectoryIcon = StoreIcon;
export default StoreMallDirectoryIcon